<div class="page-container">
  <div class="article-page container">

    <header class="article-header">
      <img [src]="article.imageUrl">


    </header>

    <div class="article-content">
      <h2>{{article.title}}</h2>

      <div class="article-summary">
        {{article.summary}}
      </div>


      <div class="article-text-content">
        <app-html-editor-wrapper [showButtons]="false" *ngIf="article.body"
                                 [value]="article.body"></app-html-editor-wrapper>

      </div>

      <div class="article-link" *ngIf="article.link" (click)="openURL()">
        {{article.link}}
      </div>


    </div>

  </div>


</div>
